import React, { useEffect, useState } from 'react';
import {
  CollapsibleContainer,
  CollapsibleContainerBody,
  CollapsibleContainerHeader,
} from '@vfuk/core-collapsible-container';
import Icon from '@vfuk/core-icon';
import AlertNotification from '@vfuk/core-alert-notification';
import { LoadingSpinner } from '@vfuk/core-loading-spinner';
import DownvotePopup from './DownvotePopup';
import { AlertWrapper } from '../styles/AccordionData.styles';
import { AccordionDataItemPropTypes, VoteObjectType } from '../Types/AccordionDataTypes';

const AccordionDataItem = ({
  accordionHandler,
  content,
  downvoteSubmitError,
  index,
  item,
  itemId,
  patchDocumentApi,
  setitemId,
  setStopSubmitLoader,
  stopSubmitLoader,
  voteHandler,
  voteObjectState,
}: AccordionDataItemPropTypes) => {
  const [isVoting, setIsVoting] = useState<boolean>(false);
  const [showOverlay, setToggleOverlay] = useState<boolean>(false);
  const [likeWasVotting, setLikeWasVotting] = useState<boolean>(false);
  const [dislikeWasVotting, setDislikeWasVotting] = useState<boolean>(false);

  const handleOnClickVote = async (id: string, voteType: string, feedbackText: string) => {
    setIsVoting(true);
    const wasVoted = await voteHandler(id, voteType, feedbackText);
    if (wasVoted) {
      if (voteType === 'downvote') {
        setToggleOverlay(!showOverlay)
      } else {
        setLikeWasVotting(true)
      }
    }
    setIsVoting(false);
  };

  const handleDowvoteVote = async (itemId: string, voteType: string, feedbackText: string, voteObject: VoteObjectType) => {
    setIsVoting(true);
    await patchDocumentApi(itemId, voteType, feedbackText, voteObject)
    setDislikeWasVotting(true)
    setIsVoting(false);
  }

  return (
    <>
      <CollapsibleContainer key={index}>
        <div
          onClick={() => {
            accordionHandler(item.id);
          }}
        >
          <CollapsibleContainerHeader>
            {item.content[0].content[0].topic}
          </CollapsibleContainerHeader>
        </div>
        <CollapsibleContainerBody>
          <div className="accordianText">
            {item.content[0].content[0].hasOwnProperty('text')
              ? item.content[0].content[0].text
              : ''}
          </div>
          <AlertWrapper key={index} id={item.id + '-vote'}>
            <AlertNotification state="warn">
              Voting limit exceeded
            </AlertNotification>
          </AlertWrapper>
          <AlertWrapper key={index + 1} id={item.id + '-request'}>
            <AlertNotification state="error">
              Upvote Request Failed, Please try again
            </AlertNotification>
          </AlertWrapper>
          <div>
            <div className="voteDiv2">
              <div className="vote-text">
                {content.upvotePopup.feedbackDesp}
              </div>
              <div className="iconVoteDiv">
                {isVoting ? (
                  <LoadingSpinner appearance="secondary" size={3} />
                ) : (
                  <>
                    <div className="countnumber">
                      {item.characteristic[0].value.numberOfHits}
                    </div>
                    <span
                      onClick={() => {
                        handleOnClickVote(item.id, 'upvote', '');
                      }}
                    >
                      <div id={item.id + '-up'} className="upvote-icon">
                        <Icon name="like" size={3} state={likeWasVotting && 'info'} />
                      </div>
                    </span>
                    <span
                      onClick={() => {
                        handleOnClickVote(item.id, 'downvote', '');
                        setitemId(item.id);
                      }}
                    >
                      <div id={item.id + '-down'} className="downvote-icon">
                        <Icon name="dislike" size={3} state={dislikeWasVotting && 'info'} />
                      </div>
                    </span>
                    <div className="countnumber">
                      {item.hasOwnProperty('feedback')
                        ? item.feedback[0].count
                        : ''}
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </CollapsibleContainerBody>
      </CollapsibleContainer>
      {/* Downvote popup open */}
      <DownvotePopup
        content={content}
        patchDocumentApi={handleDowvoteVote}
        setStopSubmitLoader={setStopSubmitLoader}
        itemId={itemId}
        stopSubmitLoader={stopSubmitLoader}
        showOverlay={showOverlay}
        setToggleOverlay={setToggleOverlay}
        voteObject={voteObjectState}
        downvoteSubmitError={downvoteSubmitError}
      />
      {/* Downvote popup closed */}
    </>
  );
};

export default AccordionDataItem;
